<template>
  <div class="settlement-apply-detail">
    <apply-detail-search @on-search="onSearch"></apply-detail-search>
    <apply-detail-title :data="titleData"></apply-detail-title>
    <apply-detail-list
      :data="datas"
      @calculate="handleCalculate"
      @refresh="startSearch"
    ></apply-detail-list>
  </div>
</template>

<script>
import ApplyDetailSearch from './component/apply-detail-search'
import ApplyDetailTitle from './component/apply-detail-title'
import ApplyDetailList from './component/apply-detail-list'
import { formatMoneyCent, formatPermil } from '@/common/filters'
import NP from 'number-precision'

export default {
  name: 'SettlementApplyDetail',
  components: { ApplyDetailSearch, ApplyDetailTitle, ApplyDetailList },
  data() {
    return {
      reqParams: {},
      datas: [],
      titleData: {
        buyerOrgName: '',
        orderNum: 0,
        pickNum: 0,
        totalActualQuantity: 0,
        totalActualWeight: 0,
        totalSettleAmount: 0
      }
    }
  },
  mounted() {
    this.startSearch()
  },
  methods: {
    handleCalculate(data) {
      this.titleData.totalSettleAmount = data
    },
    onSearch(params) {
      this.reqParams = params
      this.startSearch()
    },
    async startSearch() {
      let request = { orgId: Number(this.$route.params.orgId), ...this.reqParams }
      const { success, data } = await this.$post('settle.seller.querySettleApplySku', { request })

      if (success && data) {
        const { settleApplySkuSummaryVO, settleApplySkuDetailVOList } = data[0]
        if (settleApplySkuSummaryVO) {
          this.titleData.orderNum = settleApplySkuSummaryVO.pendingOrderNum
          this.titleData.pickNum = settleApplySkuSummaryVO.pendingDispatchNum
          this.titleData.buyerOrgName = settleApplySkuSummaryVO.buyerOrgName
          this.titleData.totalActualQuantity = settleApplySkuSummaryVO.actualQuantity
          this.titleData.totalActualWeight = settleApplySkuSummaryVO.actualWeight
          // this.titleData.totalSettleAmount = settleApplySkuSummaryVO.settleEstimateAmount;
        }
        //订单纬度合并提单
        const filterGroup = {}
        settleApplySkuDetailVOList.forEach(ele => {
          ele.$checked = true
          //结算单价
          ele.$settlePerAmount = `¥${NP.divide(ele.settlePerAmount, 100)}/${ele.chargeUnit}`
          ele.$settlePerAmountCopy = ele.$settlePerAmount
          //结算数量
          ele.$settleQuantity = `${ele.settleQuantity}件`
          ele.$settleQuantityCopy = ele.$settleQuantity
          //结算重量
          ele.$settleWeight = `${NP.divide(ele.settleWeight, 10000)}吨`
          ele.$settleWeightCopy = ele.$settleWeight
          //结算金额
          ele.$settleAmount = `¥${NP.divide(ele.settleAmount, 100)}`
          ele.$settleAmountCopy = ele.$settleAmount

          const { bizOrderNo } = ele
          if (filterGroup[bizOrderNo]) {
            filterGroup[bizOrderNo].list.push(ele)
          } else {
            const list = []
            list.push(ele)
            filterGroup[bizOrderNo] = {
              $totalQuantity: 0,
              $totalWeight: 0,
              $totalAmount: 0,
              ...ele,
              list
            }
          }
        })

        const groupArray = []
        const keys = Object.keys(filterGroup)
        keys.forEach(key => {
          groupArray.push(filterGroup[key])
        })
        this.datas = groupArray
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.settlement-apply-detail {
  min-width: 980px;
}
</style>
